import { render, staticRenderFns } from "./school.vue?vue&type=template&id=7ed99a74&"
import script from "./school.vue?vue&type=script&lang=js&"
export * from "./school.vue?vue&type=script&lang=js&"
import style0 from "./school.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports